import { Injectable } from '@angular/core';
import { HttpHeadersHelperService } from '@core/_services/http-headers-helper.service'
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@env';
import { Conference } from '@management/conferences/_models/conference';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConferenceService {

  private apiUrl: string = `${environment.apiUrl}`;
  private endPoint: string = '/Conferences';
  private headers: HttpHeaders = this.httpHeadersHelperService.getCustomHeaders();

  getAll(): Observable<Conference[]> {
    return this.http.get<Conference[]>(this.apiUrl + this.endPoint, { headers: this.headers });
  }

  constructor(private http: HttpClient,
    private httpHeadersHelperService: HttpHeadersHelperService) {
  }
}
